<div>
  <app-header></app-header>
  <main>
    <router-outlet></router-outlet>
  </main>
  @if(router.url !== '/map'){
  <app-footer></app-footer>
  }
  <p-toast />
  <p-confirmDialog acceptLabel="Si" />

  <p-dialog
    header="Informativa sui cookies"
    position="bottomright"
    [visible]="this.cookiesStore.cookieDialogVisiblity()"
    closable="false"
    draggable="false"
  >
    <p>
      Questo sito utilizza cookie per ottimizzare la tua esperienza. <br> Consulta
      l'<a
        href="https://www.regione.veneto.it/web/guest/informativa-cookies"
        target="_blank"
        rel="noopener noreferrer"
        >informativa</a
      >
      e scegli se accettare
    </p>

    <div class="actions">
      <p-button
        label="Rifiuta"
        severity="secondary"
        (click)="handleCookieAction(false)"
      />
      <p-button label="Accetta" (click)="handleCookieAction(true)" />
    </div>
  </p-dialog>
</div>

@if (loading$()) {
<app-loading-fullscreen></app-loading-fullscreen>
}
